<template>
    <div class="html-text" v-html="text"></div>
</template>
<script>
    export default {
        name: 'HtmlText',
        props: {
            text: {
                type: String,
                required: true
            },
        },
    }
</script>
<style lang="scss" scoped>
    .html-text{
        overflow: hidden;
        padding: 0 16px;
    }
</style>
